import * as Sentry from '@sentry/angular';

import { environment } from '../environments';

type SentryApp = 'web' | 'mobile';

export function initSentry(app: SentryApp): void {
  const dsn = app === 'web' ? environment.sentry.webDsn : environment.sentry.mobileDsn;

  if (!dsn) {
    return;
  }

  Sentry.init({
    dsn,
    enabled: true,
    environment: environment.sentry.environment,
    release: `innership-${app}@${environment.version}`,
    sendDefaultPii: false,
    initialScope: {
      tags: {
        app,
      },
    },
  });
}
